export default __webpack_public_path__ + "static/media/Reporting visualisation_icon.c522cf76.svg";